import './Footer.css';

function Footer() {
  return (
    <footer className="footer mt-auto py-3 w-100">
      <div className="container-fluid d-flex justify-content-between align-items-center px-4">
        <img src="/images/logo_training.png" alt="Logo Training Corporation" className="footer-logo" />
        <span className="copyright-text">
          Copyright © Training Corporation 2025
        </span>
      </div>
    </footer>
  );
}

export default Footer;
